import React, { useEffect, useState } from "react";
import Navbar from "../components/navbar/Navbar";
import MobileNavbar from "../components/navbar/MobileNavbar";
import Footer from "../components/footer/Footer";
import ClientChatBox from "../components/chat/ClientChatBox";
import DriverChatBox from "../components/chat/DriverChatBox";
import { Outlet, useLocation } from "react-router-dom";
import "./WebSiteLayout.css";
import CookiesModal from "../components/home/CookiesModal";

export default function WebSiteLayout() {
  const location = useLocation();
  const [userType, setUserType] = useState(
    typeof window !== "undefined" ? localStorage.getItem("userType") : null,
  );

  // Protected routes where footer should be hidden
  const protectedRoutes = [
    "/driver/driver-offer",
    "/driver/driver-details",
    "/driver/map",
    "/driver/driver-request",
    "/driver/driver-completed",
    "/driver/vehicle-table",
    "/driver/rechnungen-driver",
    "/driver/driver-info",
    "/user/booking",
    "/rechnungen-client",
    "/clientinfo",
  ];

  const shouldHideFooter =
    userType &&
    protectedRoutes.some((route) => location.pathname.startsWith(route));

  return (
    <div className="dashboard-layout">
      <Navbar />

      {/* الصفحات هتتحط هنا */}
      <Outlet />

      {!shouldHideFooter && <Footer />}

      {/* Mobile Bottom Navigation */}
      {/* <MobileNavbar /> */}

      {/* ClientChatBox يظهر للاتنين */}
      {(userType === "client" || userType === "driver") && (
        <ClientChatBox userType={userType} />
      )}

      {/* Cookies Modal (shown globally) */}
      <CookiesModal />

      {/* إذا كنت تريد إظهار DriverChatBox أيضاً يمكنك إزالته أو تركه */}
      {/* {userType === "driver" && (
        <DriverChatBox />
      )} */}
    </div>
  );
}
